// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__1Vwww","loader":"Loader_loader__2Vt-W","spin":"Loader_spin__3d6l_"};